import { Component, forwardRef, Inject } from '@angular/core';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';

import { API }               from '../api/api.constant';
import { ApiModel }          from '../api/models/api.model';
import { DateParserService } from '../core/services/date-parser.service';

@Component({
  selector   : 'chargify-export-cancelations',
  template: require('./chargify.export-cancelations.component.html')
})
export class ChargifyExportCancelationsComponent {
  _API : ApiModel = API;

  beginDate: string = this.dateParserService.today();
  endDate  : string = this.dateParserService.today();;

  constructor (
    public  activeModal      : NgbActiveModal,
    @Inject(forwardRef(() => DateParserService))
    private dateParserService: DateParserService
  ) {}

  export () : void {
    window.open(`${
      this._API.url
    }/chargify/cancelation_csv/${
      this.beginDate
    }/${
      this.endDate
    }`);

    this.activeModal.close();
  }
}
